import { sanitize } from 'isomorphic-dompurify'
import cs from 'classnames'
import React from 'react'
import { isExternalURL } from '../url'

const cleanupHTML = (html: string) =>
  // remove empty paragraphs
  html.replace(/<p>(\s|<br(\s\/)?>)*<\/p>/g, '')

export const HTMLDescription = ({
  description,
  cropAmount,
  className,
}: {
  description: string
  cropAmount?: number
  className?: string
}) => {
  const dirty = cropAmount
    ? description.length < cropAmount
      ? description
      : description.substring(0, cropAmount - 10).trim() + '...'
    : description

  const clean = sanitize(cleanupHTML(dirty), {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
  })

  const handleClick = e => {
    if (isExternalURL(e.target.href)) {
      e.target.target = '_blank'
      e.target.rel = 'noopener noreferrer'
    }
  }

  return description ? (
    <span
      onClick={handleClick}
      dangerouslySetInnerHTML={{
        __html: clean,
      }}
      className={cs('html-description', className)}
    />
  ) : null
}
